import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash';

import { ContentsRenderSection } from 'components/AssetManager';
import AssetUploader from 'components/AssetManager/assetUploader';
import StoryboardContext from 'components/Storyboard/context';
import { DuplicateAssetToast } from 'components/Toast';
import { toast } from 'react-toastify';
import { invalidateDuplicateAssets } from 'actions/content';

import styles from './contentManager.module.scss';
import { invalidateMediaLibrary } from 'actions/media';

export const ContentManagerSettings = ({storyboard}) => {
  const dispatch = useDispatch();
  let duplicates = useSelector(state => _.get(state, `content.duplicates`, []));

  useEffect(() => {
    if(duplicates && _.size(duplicates) > 0){

      duplicates.map( (duplicate) => {
        if(duplicate && duplicate.processed && duplicate.similarAsset){
          toast(
            <DuplicateAssetToast duplicate={duplicate} storyboard={storyboard} closeToast={()=>toast.dismiss(duplicate.id)} />,
            {
              toastId: duplicate.id,
              type: toast.TYPE.DEFAULT,
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: false,
              closeOnClick: false,
              closeButton: false,
              draggable: false
            }
          )

          let isAllProcessed = duplicates.every(duplicate => duplicate.processed == true);
          if(isAllProcessed){
            dispatch(invalidateDuplicateAssets());
          }
        }
      })
    }
  }, [duplicates]);
  
  useEffect(() => {
      dispatch(invalidateMediaLibrary());
  }, [])

  return (
    <>
    <StoryboardContext.Provider value={storyboard}>
      <div className={styles.managerSettingsContent}>
        <header className={styles.header}>
          <div className={styles.detail}>
            <div className={styles.title}>Content Manager</div>
            <div className={styles.description}>A telescopic view of all your content</div>
          </div>
          <AssetUploader handleViewChange={()=>{console.log('change')}} storyboard={storyboard}/>
        </header>
        <section className={styles.tabContainer}>
          <div className={styles.wrapper}>
            <ContentsRenderSection edit={true} uploadingAsset={false} storyboard={storyboard} />
          </div>
        </section>
      </div>
     </StoryboardContext.Provider>
    </>
  )
}
